export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    unread: state => state.list.filter(({ read }) => !read)
  },
  mutations: {
    add (state, data) {
      state.list = [
        {
          read: false,
          data
        },
        ...state.list
      ]
    },
    read (state, data) {
      state.list = state.list.map(notification =>
        (data.id && notification.data.id
          ? notification.data.id === data.id
          : notification.data === data)
          ? { ...notification, read: true }
          : notification
      )
    },
    remove (state, data) {
      state.list = state.list.filter(notification =>
        data.id && notification.data.id
          ? notification.data.id !== data.id
          : notification.data !== data
      )
    }
  },
  actions: {
    addNotification ({ commit }, data) {
      commit('add', data)
    },
    addNotifications ({ commit }, list) {
      list.forEach(data => {
        commit('add', data)
        commit('read', data)
      })
    },
    setNotificationRead ({ commit }, data) {
      commit('read', data)
    },
    setAllNotificationsRead ({ commit, getters }) {
      getters.unread.forEach(notification => commit('read', notification.data))
    },
    removeNotification ({ commit }, data) {
      commit('remove', data)
    }
  }
}
